import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'

import * as BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as vuetifyComponents from 'vuetify/components'
import * as vuetifyDirectives from 'vuetify/directives'

import Octicon from '@/components/Octicon.vue'
import BpmValue from '@/components/BpmValue.vue'

import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/themes/default.css'

import NotifyPlugin from '@/modules/vue-notification'
import velocity from 'velocity-animate'

import { tdj2 } from '@/tdj2.js'

const vuetify = createVuetify({
    components: vuetifyComponents,
    directives: vuetifyDirectives
})

const app = createApp(App)

app.component('octicon', Octicon)
app.component('bpm-value', BpmValue)

// Unlike bootstrap-vue v2's Vue.use(BootstrapVue), bootstrap-vue-next's
// createBootstrap() plugin only wires up its internal services (RTL support,
// the modal/toast orchestrator, popover/tooltip registries) - it does NOT
// register any of the <b-*> components globally. The library's own
// recommended tree-shakeable approach is per-file imports or the
// unplugin-vue-components resolver, but this app uses <b-*> tags directly
// across many components with no local imports (mirroring how bootstrap-vue
// v2 was used), so without this loop every <b-navbar>, <b-modal>, etc. in
// the app silently renders as an unresolved, unstyled custom element -
// this was the actual cause of the "broken" navbar/menu/settings panel.
// This is the maintainers' own suggested fallback for non-resolver setups,
// see https://github.com/bootstrap-vue-next/bootstrap-vue-next/issues/2550.
for (const name of BootstrapVueNext.componentNames) {
    app.component(name, BootstrapVueNext[name])
}
for (const name of BootstrapVueNext.directiveNames) {
    const directiveName = name.slice(1).replace(/([A-Z])/g, (m, letter, offset) => (offset > 0 ? '-' : '') + letter.toLowerCase())
    app.directive(directiveName, BootstrapVueNext[name])
}

app.use(router)
app.use(BootstrapVueNext.createBootstrap())
app.use(vuetify)
app.use(LoadingPlugin)
app.use(NotifyPlugin, { velocity })
app.use(contentmenu)

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

app.config.productionTip = false

app.mount('#app')

// tdj2's global event bus (src/modules/bus.js) doesn't need a component
// instance to emit on anymore (see that module for why), so unlike the
// Vue 2 version this no longer needs `this.$root` threaded through.
tdj2.fetchProfile()
